import React, { useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import { apiService } from '../../services/api'
import { useBranding } from '../../context/BrandingContext'
import LoadingSpinner from '../common/LoadingSpinner'
import '../../styles/client-pages.css'

// ── Inline SVG icons ──────────────────────────────────────────────────────────
const IcSearch  = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
const IcRocket  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>
const IcEdit    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
const IcDomain  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
const IcCard    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
const IcLayers  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>
const IcFile    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
const IcArrow   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
const IcSend    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
const IcMsg     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
const IcHelp    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
const IcChevron = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
const IcBack    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
const IcThumbUp = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>
const IcThumbDn = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"/></svg>
const IcMega    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>
const IcClose   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>

// Category icon by stored name → inline glyph (falls back to a generic file).
const CAT_ICON = { rocket: <IcRocket />, edit: <IcEdit />, domain: <IcDomain />, card: <IcCard />, layers: <IcLayers /> }
const catIcon = (name) => CAT_ICON[name] || <IcFile />

const STATUS_LABEL = { operational: 'Operational', degraded: 'Degraded', down: 'Outage' }
const STATUS_VAR = { operational: 'success', degraded: 'warning', down: 'danger' }

// Body is stored as plain text / light markdown; split into paragraphs.
const splitBody = (body) => (body || '').split(/\n{2,}/).map(s => s.trim()).filter(Boolean)
const readTime = (body) => {
  const words = (body || '').trim().split(/\s+/).filter(Boolean).length
  return `${Math.max(1, Math.round(words / 200))} min`
}
const matchesQuery = (a, q) => {
  const s = q.toLowerCase()
  return (a.title || '').toLowerCase().includes(s) || (a.body || '').toLowerCase().includes(s)
}

// ── "Was this helpful?" voting (one vote per article, remembered locally) ──────
function HelpfulVote({ articleId }) {
  const storeKey = `wiki-helpful-${articleId}`
  const [voted, setVoted] = useState(() => { try { return localStorage.getItem(storeKey) } catch { return null } })

  const vote = (value) => {
    if (voted) return
    setVoted(value)
    try { localStorage.setItem(storeKey, value) } catch {}
    apiService.post(`/wiki/articles/${articleId}/helpful`, { value }).catch(() => {})
  }

  if (voted) {
    return <span style={{ fontSize: 13, color: 'var(--success)' }}>✓ Thanks for your feedback!</span>
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
      <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Was this helpful?</span>
      <button className="btn btn-sm" onClick={() => vote('yes')}><IcThumbUp /> Yes</button>
      <button className="btn btn-sm" onClick={() => vote('no')}><IcThumbDn /> No</button>
    </div>
  )
}

// ── Article reader ────────────────────────────────────────────────────────────
function ArticleReader({ article, catTitle, onBack }) {
  const paras = splitBody(article.body)
  return (
    <>
      <div className="page-header">
        <div className="page-title">
          <button className="btn btn-sm" style={{ alignSelf: 'flex-start', marginBottom: 10 }} onClick={onBack}><IcBack /> All articles</button>
          <div className="eyebrow">{catTitle}</div>
          <h1>{article.title}</h1>
          <div className="subtitle">{readTime(article.body)} read</div>
        </div>
      </div>
      <div className="page-body" style={{ gap: 18 }}>
        <div className="card card-pad" style={{ maxWidth: 760 }}>
          {paras.length === 0 ? (
            <p style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.7, margin: 0 }}>This article doesn't have any content yet.</p>
          ) : paras.map((p, i) => {
            if (p.startsWith('# ')) return <h2 key={i} className="h2" style={{ margin: i === 0 ? '0 0 12px' : '18px 0 12px' }}>{p.slice(2)}</h2>
            return <p key={i} style={{ fontSize: 14, color: 'var(--text-soft)', lineHeight: 1.7, margin: '0 0 14px' }}>{p}</p>
          })}
          <div className="divider" style={{ margin: '18px 0' }} />
          <HelpfulVote articleId={article.id} />
          <div className="divider" style={{ margin: '18px 0' }} />
          <div className="flex items-center justify-between" style={{ gap: 12, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Still need a hand?</span>
            <Link to="/client/requests" style={{ textDecoration: 'none' }}>
              <button className="btn btn-primary btn-sm"><IcMsg /> Message your team</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

// ── Main: wiki help center ──────────────────────────────────────────────────────
const ClientSupport = () => {
  const { cmsName, supportEmail } = useBranding()
  const [query, setQuery]         = useState('')
  const [activeCat, setActiveCat] = useState(null)
  const [openFaq, setOpenFaq]     = useState(0)
  const [article, setArticle]     = useState(null)

  const { data: profile } = useQuery('client-profile', () => apiService.get('/clients/profile').then(r => r.data), { staleTime: 5 * 60 * 1000 })
  const firstName = (profile?.user_name || '').trim().split(' ')[0]

  const { data, isLoading } = useQuery('wiki', () => apiService.get('/wiki').then(r => r.data))
  const categories = data?.categories || []
  const articles   = data?.articles || []
  const faqsAll    = data?.faqs || []
  const statuses   = data?.status || []
  const banner     = data?.banner || null

  // Banner is dismissible; a fresh admin post (new updated_at) reappears.
  const [dismissedBanner, setDismissedBanner] = useState(() => { try { return localStorage.getItem('wiki-banner-dismissed') } catch { return null } })
  const showBanner = banner && dismissedBanner !== banner.updated_at
  const dismissBanner = () => {
    setDismissedBanner(banner.updated_at)
    try { localStorage.setItem('wiki-banner-dismissed', banner.updated_at) } catch {}
  }

  const catTitle = useMemo(() => Object.fromEntries(categories.map(c => [c.id, c.name])), [categories])
  // Backend already orders published articles by views desc → use the top as "popular".
  const popular = articles.slice(0, 6)

  const openArticle = (a) => {
    setArticle(a)
    apiService.post(`/wiki/articles/${a.id}/view`).catch(() => {})
  }

  if (article) return <ArticleReader article={article} catTitle={catTitle[article.category_id] || ''} onBack={() => setArticle(null)} />

  const filtering = Boolean(query) || Boolean(activeCat)
  const listArticles = filtering
    ? articles.filter(a => (!activeCat || a.category_id === activeCat) && (!query || matchesQuery(a, query)))
    : popular
  const listTitle = query ? 'Search results' : activeCat ? (catTitle[activeCat] || 'Articles') : 'Popular articles'
  const faqs = query ? faqsAll.filter(f => `${f.question} ${f.answer}`.toLowerCase().includes(query.toLowerCase())) : faqsAll
  const countFor = (id) => articles.filter(a => a.category_id === id).length
  const allOperational = statuses.length > 0 && statuses.every(s => s.state === 'operational')

  return (
    <>
      {/* Header */}
      <div className="page-header">
        <div className="page-title">
          <div className="eyebrow">Your account</div>
          <h1>Help &amp; support</h1>
          <div className="subtitle">Answers, guides, and a direct line to your team.</div>
        </div>
        <div className="flex gap-2 items-center">
          <Link to="/client/requests" style={{ textDecoration: 'none' }}>
            <button className="btn btn-primary"><IcMsg /> Message your team</button>
          </Link>
        </div>
      </div>

      <div className="page-body" style={{ gap: 18 }}>
        {/* Broadcast banner — posted by the team from the admin Help Center */}
        {showBanner && (
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: '14px 16px', borderRadius: 14, background: 'var(--accent-soft)', border: '1px solid var(--border-accent)' }}>
            <span className="icon-tile accent" style={{ width: 34, height: 34, fontSize: 16, flexShrink: 0 }}><IcMega /></span>
            <div style={{ flex: 1, minWidth: 0 }}>
              {banner.headline && <div style={{ fontSize: 14, fontWeight: 600 }}>{banner.headline}</div>}
              {banner.message && <div style={{ fontSize: 12.5, color: 'var(--text-soft)', marginTop: 3, lineHeight: 1.55 }}>{banner.message}</div>}
            </div>
            <button className="btn btn-sm btn-icon" onClick={dismissBanner} title="Dismiss"><IcClose /></button>
          </div>
        )}

        {/* Search hero */}
        <div className="help-search-wrap" style={{ maxWidth: 'none', margin: 0 }}>
          <div style={{ fontSize: 20, fontWeight: 600, letterSpacing: '-0.02em', marginBottom: 14 }}>
            How can we help{firstName ? `, ${firstName}` : ''}?
          </div>
          <div className="help-search">
            <IcSearch />
            <input
              placeholder='Search articles — e.g. "change my logo"'
              value={query}
              onChange={e => { setQuery(e.target.value); setActiveCat(null) }}
            />
            {query
              ? <button className="btn btn-sm btn-icon" onClick={() => setQuery('')} title="Clear">✕</button>
              : <span className="kbd">↵</span>}
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap' }}>
            {['Editing text', 'Adding a page', 'Custom domain', 'Billing', 'Analytics'].map(t => (
              <button key={t} className="btn btn-sm" onClick={() => { setQuery(t); setActiveCat(null) }}>{t}</button>
            ))}
          </div>
          <div style={{ position: 'absolute', right: -40, bottom: -60, width: 200, height: 200, borderRadius: '50%', background: 'var(--accent-soft)', pointerEvents: 'none', filter: 'blur(50px)' }} />
        </div>

        {isLoading ? (
          <div style={{ padding: 60 }}><LoadingSpinner /></div>
        ) : (
        <>
        {/* Categories */}
        <div className="bento" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: 14 }}>
          {categories.map(c => {
            const active = activeCat === c.id
            return (
              <div
                key={c.id}
                className="help-cat"
                style={active ? { borderColor: 'var(--border-accent)', background: 'var(--accent-soft)' } : undefined}
                onClick={() => { setActiveCat(active ? null : c.id); setQuery('') }}
              >
                <span className="icon-tile" style={{ width: 36, height: 36, fontSize: 16 }}>{catIcon(c.icon)}</span>
                <div style={{ fontSize: 14, fontWeight: 600, marginTop: 2 }}>{c.name}</div>
                <div style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{countFor(c.id)} article{countFor(c.id) === 1 ? '' : 's'}</div>
              </div>
            )
          })}
        </div>

        <div className="bento" style={{ gridTemplateColumns: '1.5fr 1fr', gap: 14, alignItems: 'flex-start' }}>
          {/* Articles */}
          <div className="card card-pad">
            <div className="flex items-center justify-between" style={{ marginBottom: 12, gap: 10 }}>
              <h2 className="h2">{listTitle}</h2>
              {filtering && <button className="btn btn-sm" onClick={() => { setQuery(''); setActiveCat(null) }}>Clear</button>}
            </div>
            {listArticles.length === 0 ? (
              <div style={{ padding: '24px 0', textAlign: 'center', color: 'var(--text-faint)', fontSize: 12.5 }}>
                No articles found{query ? ` for “${query}”` : ''}. Try a different search, or message your team.
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {listArticles.map(a => (
                  <button key={a.id} className="help-article" onClick={() => openArticle(a)}>
                    <span className="icon-tile" style={{ width: 28, height: 28, fontSize: 13 }}><IcFile /></span>
                    <span style={{ flex: 1, fontSize: 13, color: 'var(--text)' }}>{a.title}</span>
                    <span style={{ color: 'var(--text-muted)', display: 'inline-flex' }}><IcArrow /></span>
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Contact + status */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="card card-pad">
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <div className="avatar-stack">
                  <div className="avatar avatar-grad-1">SV</div>
                  <div className="avatar avatar-grad-5">TL</div>
                  <div className="avatar avatar-grad-3">RP</div>
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.3 }}>Your {cmsName} team</div>
                  <div style={{ fontSize: 11.5, color: 'var(--success)', marginTop: 2 }}>● Online · replies in ~1 hour</div>
                </div>
              </div>
              <div style={{ fontSize: 12.5, color: 'var(--text-soft)', lineHeight: 1.55 }}>
                The same people who built your site. Send a message and a real human gets back to you.
              </div>
              <Link to="/client/requests" style={{ textDecoration: 'none', display: 'block' }}>
                <button className="btn btn-primary" style={{ width: '100%', marginTop: 14 }}><IcSend /> Start a conversation</button>
              </Link>
              {supportEmail && (
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 10, textAlign: 'center' }}>
                  or email <a href={`mailto:${supportEmail}`} style={{ color: 'var(--accent-3)', textDecoration: 'none' }}>{supportEmail}</a>
                </div>
              )}
            </div>

            <div className="card card-pad">
              <div className="flex items-center justify-between">
                <h2 className="h2">System status</h2>
                <span className={`badge badge-${allOperational ? 'success' : 'warning'}`}><span className="badge-dot" /> {allOperational ? 'Operational' : 'Issues reported'}</span>
              </div>
              <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {statuses.map(s => (
                  <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5 }}>
                    <span className="dot-live" style={{ background: `var(--${STATUS_VAR[s.state]})`, boxShadow: `0 0 0 4px var(--${STATUS_VAR[s.state]}-soft)` }} />
                    <span style={{ color: 'var(--text-soft)', flex: 1 }}>{s.label}</span>
                    <span style={{ color: 'var(--text-muted)', fontSize: 11.5 }}>{STATUS_LABEL[s.state] || s.state}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="card card-pad">
          <h2 className="h2" style={{ marginBottom: 6 }}>Frequently asked</h2>
          {faqs.length === 0 ? (
            <div style={{ padding: '16px 0', color: 'var(--text-faint)', fontSize: 12.5 }}>No matching questions.</div>
          ) : faqs.map((f, i) => (
            <div key={f.id} className="faq-item" style={{ border: 'none', borderRadius: 0, marginBottom: 0, overflow: 'visible', borderBottom: '1px solid var(--border)' }}>
              <button className={`faq-q ${openFaq === i ? 'open' : ''}`} onClick={() => setOpenFaq(openFaq === i ? -1 : i)}>
                <span style={{ color: 'var(--accent-3)', display: 'inline-flex' }}><IcHelp /></span>
                {f.question}
                <span className="chev"><IcChevron /></span>
              </button>
              {openFaq === i && <div className="faq-a">{f.answer}</div>}
            </div>
          ))}
        </div>
        </>
        )}
      </div>
    </>
  )
}

export default ClientSupport
